import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import DSBox from "../../views/system-design/DSBox";
import DSTextField from "../../views/system-design/DSTextField";
import DSMenuItem from "../../views/system-design/DSMenuItem";
import DSTypography from "../../views/system-design/DSTypography";

const EditableProfile = (props: {
  type: "long" | "short" | "select";
  default: string;
  onChange: (value: string) => void;
  style: React.CSSProperties;
  active?: boolean;
  options?: string[];
  maxLength?: number;
}) => {
  const [active, setActive] = useState(props.active ? props.active : false);
  const [newVal, setNewVal] = useState<string>();
  const [val, setVal] = useState<string>("");
  const [warning, setWarning] = useState("");
  const [countChar, setCountChar] = useState<number>();
  const iconSize = parseFloat(props.style.fontSize!.valueOf().toString()) * 7;
  const checkLengthVal = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    setVal(e.target.value);
    props.maxLength && setCountChar(props.maxLength - e.target.value.length);
    setWarning("");
  };

  useEffect(() => {
    props.maxLength && val && val.length > props.maxLength
      ? setWarning(`The maximum length is ${props.maxLength} charecters`)
      : setWarning("");
  }, [val, props.maxLength]);
  useEffect(() => {
    active ? setVal(newVal ? newVal : props.default) : setVal("");
  }, [active, newVal, props.default]);

  return (
    <DSBox
      style={props.style}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        fontSize: "1.4em",
      }}
    >
      {active ? (
        <DSBox sx={{ display: "flex", flexDirection: "column" }}>
          <DSBox sx={{ display: "flex", alignItems: "center" }}>
            {props.type === "long" ? (
              <DSTextField
                autoFocus
                multiline
                minRows={3}
                size="small"
                onChange={checkLengthVal}
                defaultValue={newVal ? newVal : props.default}
              />
            ) : props.type === "select" ? (
              <DSTextField
                autoFocus
                select
                size="small"
                defaultValue={newVal ? newVal : props.default}
                onChange={(e) => {
                  setVal(e.target.value);
                }}
              >
                {props.options?.map((o) => (
                  <DSMenuItem key={o} value={o}>
                    {o}
                  </DSMenuItem>
                ))}
              </DSTextField>
            ) : (
              <DSTextField
                autoFocus
                size="small"
                onChange={checkLengthVal}
                defaultValue={newVal ? newVal : props.default}
              />
            )}
            <SaveIcon
              style={{ fontSize: iconSize, marginLeft: 10 }}
              sx={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                if (props.maxLength && val && val.length > props.maxLength) {
                  setWarning("Can not save - to many charecters");
                  return;
                }
                props.onChange(val);
                setActive(false);
                setNewVal(val);
              }}
            />
          </DSBox>
          {countChar === undefined ? (
            <></>
          ) : countChar < 0 ? (
            <DSTypography sx={{ color: "error.main", fontSize: 10 }}>
              To many characters: {countChar}
            </DSTypography>
          ) : (
            <DSTypography sx={{ color: "success.main", fontSize: 10 }}>
              You have {countChar} characters left
            </DSTypography>
          )}
          {warning && (
            <DSTypography sx={{ color: "error.main", fontSize: 10 }}>
              {warning}
            </DSTypography>
          )}
        </DSBox>
      ) : (
        <DSBox
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <DSTypography
            sx={{
              fontSize: "0.8em",
              margin: 0,
              marginRight: "10px",
              textAlign: "center",
            }}
          >
            {newVal ? newVal : props.default}
            <EditIcon
              style={{ fontSize: iconSize, marginLeft: 10 }}
              sx={{ cursor: "pointer", verticalAlign: "middle" }}
              onClick={(e: any) => {
                e.stopPropagation();
                setActive(true);
              }}
            />
          </DSTypography>
        </DSBox>
      )}
    </DSBox>
  );
};

export default EditableProfile;
